import { createContext, useContext } from 'react';

// Presentation data/callbacks only; policy stays in App's session coordinator.
export const SessionPresentationContext = createContext(null);
export const useSessionPresentation = () => useContext(SessionPresentationContext);
